import { Directive, inject, Input, ViewContainerRef } from '@angular/core';
import { Calendar } from 'primeng/calendar';
import { UiFormItemDirective } from './ui-form-item.directive';
import { TimeConstraintCalendarFooterComponent } from './time-constraint-calendar-footer.component';

@Directive({
    standalone: true,
    selector: '[uiCalendar]',
})
export class UiCalendarDirective extends UiFormItemDirective {

    @Input({ required: true }) pageCode: string;
    @Input({ alias: 'uiCalendar', required: true }) controlName: string;

    primeNgCalendar: Calendar;

    constructor(primeNgCalendar: Calendar) {
        super(primeNgCalendar.el)
        this.primeNgCalendar = primeNgCalendar;
        primeNgCalendar.appendTo = 'body';
        primeNgCalendar.showClear = false;
        primeNgCalendar.dateFormat = 'dd.mm.yy';
    }

}
